import { FC } from 'react';

import Box from '@mui/material/Box/Box';

import {
  ContactFormWrapper,
  ContactFormText,
  WebWrapper,
  ContactFormDescription,
  ContactFormButtonsWrapper,
  InformationField,
} from './ContactForm.style';
import { useIsMobile } from 'hooks/useIsMobile';

import { colors } from 'styles';

import { useContactFormData } from 'hooks/useContactFormData';

import TopWeb from 'assets/contact-form/top-web.webp';
import BottomWeb from 'assets/contact-form/button-web.webp';

import { ContactFormType } from 'types/contact-us';
import { policyMeta } from 'constants/pages';
import { Button } from 'components/Buttons';
import { useNavigate } from 'react-router-dom';

interface ContactFormProps {
  onClick: () => void;
  isShowTermsAndConditions?: boolean;
  isCTABlock?: boolean;
}

export const ContactForm: FC<ContactFormProps> = ({
  onClick,
  isShowTermsAndConditions = false,
  isCTABlock = false,
}) => {
  const {
    title,
    description,
    additionalText,
    buttonLabel,
    type,
    additionalButton,
    additionalButtonLink,
    buttonLink,
    padding,
  } = useContactFormData(isCTABlock);
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  return (
    <ContactFormWrapper id="contact-us" mt="auto" isCTABlock={isCTABlock} padding={padding}>
      <WebWrapper left="0" top="0">
        <img src={TopWeb} alt="top web" />
      </WebWrapper>

      <WebWrapper bottom="-30%" right="0">
        <img src={BottomWeb} alt="bottom web" />
      </WebWrapper>

      <ContactFormText isCTABlock={isCTABlock || !!description}>{title}</ContactFormText>

      {description && <ContactFormDescription>{description}</ContactFormDescription>}

      <Box marginTop={description ? '32px' : '48px'} width="100%">
        <ContactFormButtonsWrapper>
          {additionalButton && !(type === ContactFormType.RESOURCES && isCTABlock) && (
            <Button
              btnType="secondary"
              key={additionalButton}
              width={isMobile ? 'full' : 240}
              onClick={() => {
                if (additionalButtonLink) {
                  navigate(additionalButtonLink);
                } else {
                  onClick();
                }
              }}
              aria-label={additionalButton}
            >
              {additionalButton}
            </Button>
          )}

          {buttonLink === '' ? (
            <Button
              btnType={!isCTABlock ? 'tertiary' : 'primary'}
              onClick={onClick}
              aria-label={buttonLabel}
              width={isMobile ? 'full' : 240}
            >
              {buttonLabel}
            </Button>
          ) : (
            <Button width={isMobile ? 'full' : 240} btnType="tertiary">
              <a href={buttonLink} target="_blank" rel="noreferrer">
                {buttonLabel}
              </a>
            </Button>
          )}
        </ContactFormButtonsWrapper>
      </Box>

      {type === ContactFormType.RESOURCES && additionalText && (
        <Box marginTop="32px">
          <ContactFormDescription
            sx={{
              marginTop: '0',
            }}
          >
            {additionalText}
          </ContactFormDescription>
        </Box>
      )}

      {isShowTermsAndConditions && (
        <Box marginTop="32px" padding="0 24px">
          <InformationField>
            By clicking Subscribe you&apos;re confirming that you agree with our{' '}
            <a
              href={policyMeta.url}
              target="_blank"
              rel="noreferrer"
              style={{
                color: colors.white,
              }}
            >
              Terms and Conditions.
            </a>
          </InformationField>
        </Box>
      )}
    </ContactFormWrapper>
  );
};
